import http from "@/services/http";

export async function fetch(id: string, numposts: number) {
  const { data } = await http().get(
    `${window.env.APOLLO_MIDDLEWARE_API_LOCATION}/DiscussionThreads?topicId=${id}&numPosts=${numposts}`
  );
  return data;
}
